import dayjs from "dayjs";

import { Option } from "@/@types/generics/Option";
import { defaultRiskClassification } from "@/components/sintegrada/Selects/RiskClassificationSelect";
import { defaultGender } from "@/components/GenderSelect";
import { ClinicOrSpecialtyOptionValue } from "@/components/sintegrada/Selects/ClinicOrSpecialtySelect";
import { defaultProfessional } from "@/components/sintegrada/Selects/ProfessionalSelect";

const startDate = dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm");
const endDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");

export const attendanceFilterInitialValues = {
	startDate,
	endDate,
	clinicOrSpecialty: {} as Option<ClinicOrSpecialtyOptionValue>,
	riskClassification: defaultRiskClassification,
	gender: defaultGender,
	youngerAge: "",
	olderAge: "",
	professional: defaultProfessional,
	resumeByProfessional: false,
};

export type TypeofAttendanceFilterInitialValues = typeof attendanceFilterInitialValues;
